import React, { useState, useEffect, useCallback } from "react";
import Footer from "../../components/Footer/Footer";
import CylindersProduct from "../../components/CylindersProductCard/CylindersProduct";
import { useCart } from "../../components/CartContext/CartContext";

import RefillModalSelection from "../../components/RefillModalSelection/RefillModalSelection";
import SectionTitle from "../../components/SectionTitle/SectionTitle";

import { ProductService } from "../../APIs";
import CartModal from "../../components/ModalImtemAdded/ModalItemAdded";
import Header from "../../components/Header/Header";
import { useNotification } from "../../components/Toast/Notification";
import { Puff } from "react-loader-spinner";
import { Images } from "../../assets/assets";
import faqServiceInstance from "../../APIs/faq";

import { Link } from "react-router-dom";

interface FAQ {
  question: string;
  answer: string;
}

const Loader: React.FC = () => {
  return (
    <div className="flex items-center justify-center">
      <Puff
        visible={true}
        height="60"
        width="60"
        color="#75A7AD"
        ariaLabel="puff-loading"
      />
    </div>
  );
};

export interface Product {
  id: number;
  title: string;
  price: number;
  image: string;
  banner: string;
  order_type?: string;
  quantity?: string;
}

const Spare = () => {
  const [products, setProducts] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [isCartModalVisible, setIsCartModalVisible] = useState(false);

  const { notify } = useNotification();

  const {
    cart,
    
    handleIncrease,
    handleDecrease,
    isUpdating,
    isDecreasing,
 
    addToCart,
  } = useCart();

  const [selectedBanner, setSelectedBanner] = useState<string>("");
  const [selectedProductId, setSelectedProductId] = useState<number | null>(
    null
  );
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [quantity, setQuantity] = useState<number>(1);
  const [orderType, setOrderType] = useState<string>("buy");
  const [selectedCategoryId, setSelectedCategoryId] = useState<any>(2);
  const [faqs, setFaqs] = useState<FAQ[]>([]);

  const [addedProduct, setAddedProduct] = useState<any | null>(null);

  const [selectedProduct, setSelectedProduct] = useState<any | null>(null);

  useEffect(() => {
    const fetchSelectedProduct = products.find(
      (product) => product.id === selectedProductId
    );
    setSelectedProduct(fetchSelectedProduct || null);
  }, [selectedProductId, products]);
  const handleCardClick = (banner: string, id: number, orderType: string) => {
    setSelectedBanner(banner);
    setSelectedProductId(id);
    setOrderType(orderType);
    setErrorMessage("");
    setQuantity(1);
  };

  const [isInCart, setIsInCart] = useState<boolean>(false);
  const checkIfInCart = useCallback(() => {
    if (!selectedProduct || !cart || !Array.isArray(cart)) return false;

    const productInCart = cart.find(
      (item: any) =>
        item.sku === selectedProduct.sku || item.id === selectedProduct.id
    );

    if (productInCart) {
      setAddedProduct(productInCart);
      return true;
    }

    return false;
  }, [selectedProduct, cart, setAddedProduct]);

  useEffect(() => {
    setIsInCart(checkIfInCart());
  }, [cart, selectedProduct, checkIfInCart]);



  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedOption, setSelectedOption] = useState<string | null>(null);

 

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleOptionSelect = (option: string) => {
    setSelectedOption(option);
    setIsModalVisible(false);

    if (option === "art") {
      handleCardClick(
        "https://sodastream.com/cdn/shop/files/spare_2048pxX2048pxcopy2_9dc8c174-153a-48a6-8c25-6d3b90daf98b.png?v=1708694033",
        36,
        orderType
      );
    } else if (option === "terra") {
      handleCardClick(
        "https://sodastream.com/cdn/shop/products/bundle-blue-cyl-US.png?v=1708601134",
        31,
        orderType
      );
    }
  };

  const cards = [
    {
      key: "terra",
      title: "Terra",
      description: "Uses CQC cylinders",
      imgSrc:
        "http://res.cloudinary.com/brabenjos/image/upload/v1704885569/sodastream/1704885569491.jpg",
    },
    {
      key: "art",
      title: "Art",
      description: "Uses CQC cylinders",

      imgSrc:
        "http://res.cloudinary.com/brabenjos/image/upload/v1704519766/sodastream/1704519766224.jpg",
    },
  ];
  const fetchProductData = useCallback(async () => {
    setLoading(true);
    try {
      const { data, error } = await ProductService.getAllProducts();
      if (data) {
        const filteredData = data.filter(
          (product) =>
            product.product_type === "cylinders" && product.category === "spare"
        );
        setProducts(filteredData);

      } else {
        console.error("Error fetching products:", error);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (products.length === 0) {
      fetchProductData();
    }
  }, [fetchProductData, products.length]);
  const groupedCards = [];
  for (let i = 0; i < cards.length; i += 2) {
    groupedCards.push(cards.slice(i, i + 2));
  }

  useEffect(() => {
    const id = parseInt(selectedCategoryId, 10);

    if (!isNaN(id)) {
      fetchFaqByCategory(id);
    } else {
      console.error("Invalid category ID:", selectedCategoryId);
    }
  }, [selectedCategoryId]);

  const fetchFaqByCategory = async (category_id: number) => {
    try {
      const { data, error } = await faqServiceInstance.getFaqsByCategory(
        category_id
      );

      if (data) {
        setFaqs(data);

       
      } else {
        console.error("Error fetching FAQs:", error);
      }
    } catch (error) {
      console.error("Error fetching FAQs:", error);
    }
  };

  const handleProductDecrease = () => {
    if (selectedProduct || addedProduct) {
      handleDecrease(selectedProduct);
    }
  };

  const handleProductIncrease = () => {
    // setIsIncreasing(true);
    if (selectedProduct || addedProduct) {
      handleIncrease(selectedProduct);
    }
    // setIsIncreasing(false);
  };


  useEffect(() => {
    const fetchProductsAndStock = async () => {
      setLoading(true);
      try {
        const { data, error } = await ProductService.getAllProducts();
        if (data) {
          const filteredData = data.filter(
            (product) =>
              product.product_type === "cylinders" &&
              product.category === "spare"
          );
          setProducts(filteredData);
         

          await fetchCylinderStock(filteredData);
        } else {
          console.error("Error fetching products:", error);
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoading(false);
      }
    };

    if (products.length === 0) {
      fetchProductsAndStock();
    }
  }, [fetchProductData, products.length]);

  const [cylinderStocks, setCylinderStocks] = useState<Record<string, number>>(
    {}
  );
  const [cylinderPrincipals, setCylinderPrincipals] = useState<
    Record<string, string>
  >({});

  // Add this state to track loading status for each product
  const [loadingStockBySku, setLoadingStockBySku] = useState<
    Record<string, boolean>
  >({});

  // Then modify your fetchCylinderStock function
  const fetchCylinderStock = async (cylinderProducts: any[]) => {
    if (!cylinderProducts || cylinderProducts.length === 0) return;

    const stockData: { [key: string]: number } = {};
    const principleData: { [key: string]: any } = {};

    const initialLoadingState: Record<string, boolean> = {};
    cylinderProducts.forEach((product) => {
      if (product.sku) {
        initialLoadingState[product.sku] = true;
      }
    });
    setLoadingStockBySku(initialLoadingState);

    const stockPromises = cylinderProducts.map(async (product) => {
      try {
        const skuNumber = Number(product?.sku);
        if (!isNaN(skuNumber)) {
          const response = await ProductService.getStockByItemCode(skuNumber);
          if (response.data) {
            stockData[product.sku || ""] = response.data.quantity;
            principleData[product.sku || ""] = response.data.principle;
          }

          setLoadingStockBySku((prev) => ({
            ...prev,
            [product.sku || ""]: false,
          }));
        }
      } catch (error) {
        console.error(
          `Error fetching stock for product ${product.sku}:`,
          error
        );

        setLoadingStockBySku((prev) => ({
          ...prev,
          [product.sku || ""]: false,
        }));
      }
    });

    await Promise.all(stockPromises);

    setCylinderStocks(stockData);
    setCylinderPrincipals(principleData);
  };

  useEffect(() => {
    fetchCylinderStock(products);

    const handleBeforeUnload = () => {
    
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <>
  <div className="">
  <Header
    title="Spare Cylinders"
    subTitle=""
    backgroundImg={Images.Page6BG}
    textBackground="GAS CYLINDERS"
    desktopHeight="60vh"
  />
  <SectionTitle title="Buy some spare cylinders" />
  
  <section className="px-4 md:px-8 lg:px-20 py-8 md:py-12 lg:py-20">
    <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 lg:items-start">
      
      {/* Left Column - Products */}
      <div className="flex-1 lg:flex-[0_0_55%]">
        <div className="bg-white">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-[#005D6E] text-xl font-black leading-normal">
              Which cylinder do you use?
            </h2>
            <Link 
              target="_blank" 
              to={'https://support-za.sodastream.com/hc/en-za/categories/12483126697883-CO2-Refills'}
            >
              <p className="text-[#005D6E] underline cursor-pointer text-xs font-black leading-normal tracking-wider">
                Not Sure?
              </p>
            </Link>
          </div>
          
          {loading ? (
            <Loader />
          ) : (
            <div className="flex flex-col md:flex-row gap-4 w-full">
              {products.map((product) => {
                const productInCart = cart.some(
                  (item) => item.sku === product.sku || item.id === product.id
                );
            
                return (
                  <CylindersProduct
                    key={product.id}
                    id={product.id}
                    title={product.name}
                    price={product.price}
                    image={product.image}
                    banner={product.banner}
                    sku={product.sku}
                    isSelected={selectedProductId === product.id}
                    stock={cylinderStocks[product.sku]}
                    isInCart={productInCart}
                    loading={loadingStockBySku[product.sku]} 
                    onAddToCart={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setSelectedProduct(product);
                      addToCart(product, 1);
                      setIsCartModalVisible(true);
                    }}
                    onViewCart={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setSelectedProduct(product);
                      setIsCartModalVisible(true);
                    }}
                    onClick={(banner) =>
                      handleCardClick(banner, product.id, orderType)
                    }
                  />
                );
              })}
            </div>
          )}
        </div>
      </div>
      
      {/* Right Column - Image with constrained height */}
      <div className="flex-1 lg:flex-[0_0_45%] flex items-start justify-center lg:sticky lg:top-8">
        <div className="w-full  overflow-hidden rounded-lg">
          <img
            src={selectedBanner || "http://res.cloudinary.com/brabenjos/image/upload/v1746002903/sodastream/1746002903183.png"}
            alt="Co2 gas cylinders"
            className="w-full h-full object-contain"
          />
        </div>
      </div>
      
    </div>
  </section>

  <div>
    <RefillModalSelection
      isModalVisible={isModalVisible}
      handleCancel={handleCancel}
      handleOptionSelect={handleOptionSelect}
      groupedCards={groupedCards}
    />
    <CartModal
      isCartModalVisible={isCartModalVisible}
      setIsCartModalVisible={setIsCartModalVisible}
      addedProduct={addedProduct}
      handleIncrease={handleProductIncrease}
      handleDecrease={handleProductDecrease}
      availableStock={cylinderStocks[addedProduct?.sku]}
      quantity={0}
      isUpdating={isUpdating}
      isDecreasing={isDecreasing}
      stock={cylinderStocks[addedProduct?.sku]}
    />
    <Footer />
  </div>
</div>
    </>
  );
};

export default Spare;
